export const vakDimensionsOptions = [{
  label: '14*10*10(inch)', text: '14*10*10(inch)', value: '14*10*10', size: '14*10*10', weight: 1,
}, {
  label: '10*8*8(inch)', text: '10*8*8(inch)', value: '10*8*8', size: '10*8*8', weight: 1,
}, {
  label: '10*10*8(inch)', text: '10*10*8(inch)', value: '10*10*8', size: '10*10*8', weight: 1
}, {
  label: '14*10*6(inch)', text: '14*10*6(inch)', value: '14*10*6', size: '14*10*6', weight: 1.2
}, {
  label: '16*10*6(inch)', text: '16*10*6(inch)', value: '16*10*6', size: '16*10*6', weight: 1.2
}, {
  label: 'Other', text: 'Other', value: 'other'
}];
export const vakLogisticCarrierOptions = [
  {
  label: 'USPS FIRST CLASS', text: 'USPS FIRST CLASS', value: 'usps_first_class_mail', type: 'usps_first_class_mail', size: '13*10*0.5', weight: 0.1
}, 
  {
  label: 'USPS GROUND ADVANTAGE', text: 'USPS GROUND ADVANTAGE', value: 'usps_ground_advantage', type: 'usps_ground_advantage',
}, 
{
  label: 'USPS PRIORITY MAIL-ENV', text: 'USPS PRIORITY MAIL-ENV', value: 'usps_priority_mail_env', type: 'usps_priority_mail', size: '13*10*0.5'
}, {
  label: 'USPS PRIORITY MAIL-PKG', text: 'USPS PRIORITY MAIL-PKG', value: 'usps_priority_mail_pkg', type: 'usps_priority_mail',
}, {
  label: 'USPS PARCEL SELECT GROUND', text: 'USPS PARCEL SELECT GROUND', value: 'usps_parcel_select', type: 'usps_parcel_select',
}, {
  label: 'FEDEX 2 DAY-PAK', text: 'FEDEX 2 DAY-PAK', value: 'fedex_2day_pak', type: 'fedex_2day', size: '15*13*0.5'
}, {
  label: 'FEDEX 2 DAY-ENV', text: 'FEDEX 2 DAY-ENV', value: 'fedex_2day_env', type: 'fedex_2day', size: '15*13*0.5'
}, {
  label: 'FEDEX 2 DAY-SBOX', text: 'FEDEX 2 DAY-SBOX', value: 'fedex_2day_sbox', type: 'fedex_2day', size: '8.75*2.6875*11.3125'
}, {
  label: 'FEDEX 2 DAY-MBOX', text: 'FEDEX 2 DAY-MBOX', value: 'fedex_2day_mbox', type: 'fedex_2day', size: '8.75*4.375*11.3125'
}, {
  label: 'FEDEX 2 DAY-LBOX', text: 'FEDEX 2 DAY-LBOX', value: 'fedex_2day_lbox', type: 'fedex_2day', size: '8.75*7.75*11.3125'
}, {
  label: 'Fedex Ground', text: 'Fedex Ground', value: 'fedex_ground', type: 'fedex_ground',
}, {
  label: 'Fedex Home Delivery', text: 'Fedex Home Delivery', value: 'fedex_home_delivery', type: 'fedex_home_delivery',
}, {
  label: 'Fedex Express Saver', text: 'Fedex Express Saver', value: 'fedex_express_saver', type: 'fedex_express_saver',
}, {
  label: 'Fedex 2day AM-PAK', text: 'Fedex 2day AM-PAK', value: 'fedex_2day_am_pak', type: 'fedex_2day_am', size: '15*13*0.5'
}, {
  label: 'Fedex 2day AM-ENV', text: 'Fedex 2day AM-ENV', value: 'fedex_2day_am_env', type: 'fedex_2day_am', size: '15*13*0.5'
}, {
  label: 'Fedex 2day AM-SBOX', text: 'Fedex 2day AM-SBOX', value: 'fedex_2day_am_sbox', type: 'fedex_2day_am', size: '8.75*2.6875*11.3125'
}, {
  label: 'Fedex 2day AM-MBOX', text: 'Fedex 2day AM-MBOX', value: 'fedex_2day_am_mbox', type: 'fedex_2day_am', size: '8.75*4.375*11.3125'
}, {
  label: 'Fedex 2day AM-LBOX', text: 'Fedex 2day AM-LBOX', value: 'fedex_2day_am_lbox', type: 'fedex_2day_am', size: '8.75*7.75*11.3125'
}, {
  label: 'Fedex 2day AM-PKG', text: 'Fedex 2day AM-PKG', value: 'fedex_2day_am_pkg', type: 'fedex_2day_am',
}, {
  label: 'Fedex Priority overnight-PAK', text: 'Fedex Priority overnight-PAK', value: 'fedex_priority_overnight_pak', type: 'fedex_priority_overnight', size: '15*13*0.5'
}, {
  label: 'Fedex Priority overnight-ENV', text: 'Fedex Priority overnight-ENV', value: 'fedex_priority_overnight_env', type: 'fedex_priority_overnight', size: '15*13*0.5'
}, {
  label: 'Fedex Priority overnight-SBOX', text: 'Fedex Priority overnight-SBOX', value: 'fedex_priority_overnight_sbox', type: 'fedex_priority_overnight', size: '8.75*2.6875*11.3125'
}, {
  label: 'Fedex Priority overnight-MBOX', text: 'Fedex Priority overnight-MBOX', value: 'fedex_priority_overnight_mbox', type: 'fedex_priority_overnight', size: '8.75*4.375*11.3125'
}, {
  label: 'Fedex Priority overnight-LBOX', text: 'Fedex Priority overnight-LBOX', value: 'fedex_priority_overnight_lbox', type: 'fedex_priority_overnight', size: '8.75*7.75*11.3125'
}, {
  label: 'Fedex Priority overnight-PKG', text: 'Fedex Priority overnight-PKG', value: 'fedex_priority_overnight_pkg', type: 'fedex_priority_overnight',
},
//   {
//   label: 'Fedex Smartpost parcel select', text: 'Fedex Smartpost parcel select', value: 'fedex_smartpost_parcel_select', type: 'fedex_smartpost_parcel_select',
// }
];

export const vakInsuranceOptions = [
  {
    id: '1', title: 'None', text: 'None', value: 'none',
  },
  {
    id: '2', title: 'ParcelGuard', text: 'ParcelGuard', value: 'parcelGuard',
  },
  {
    id: '3', title: 'Carrier', text: 'Carrier', value: 'carrier',
  },
]

export const vakUspsSignatureOptions = [
  {
    id: '1', title: 'None', text: 'None', value: 'none',
  },
  {
    id: '2', title: 'Signature', text: 'Signature', value: 'signature',
  },
]
export const vakFedexSignatureOptions = [
  {
    id: '1', title: 'None', text: 'None', value: 'none',
  },
  {
    id: '2', title: 'Direct Signature', text: 'Direct Signature', value: 'direct_signature',
  },
]



// WEBPACK FOOTER //
// ./master/jsx/utils/constant.js